import { InjectionToken } from '@angular/core';

export const DISPLAY_ERROR_TOKEN = new InjectionToken<Function>('DisplayErrorToken');
export const LOG_ERROR_TOKEN = new InjectionToken<Function>('LogErrorToken');
export const REDIRECT_ADDRESS_TOKEN = new InjectionToken<string>('RedirectAddressToken');
export const MESSAGE_TOKEN = new InjectionToken<string | undefined>('MessageToken');
export const STATIC_ERROR_ID_TOKEN = new InjectionToken<string | undefined>('StaticErrorIdToken');
